/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { LiveManagementListLivecarpResponse } from './LiveManagementListLivecarpResponse';

export type LiveManagementListLivecarpResponseApiRespoonse = {
    data?: LiveManagementListLivecarpResponse;
    status?: LiveManagementListLivecarpResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace LiveManagementListLivecarpResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

